import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Typography, VertButton, VertImage } from '@vertem-core/vertice-ds';

// import GiftPackage from '../../Assets/images/gift-package.svg'
// import Stars from '../../Assets/images/stars.svg';
import './GiftStyles.less';

const GiftBanner = ({
  titleText, subtitleText, buttonText, hasButton,
}) => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const newScroll = window.scrollY;
      setScroll(newScroll);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="gift-banner"
    // style={{ backgroundPosition: `45% ${scroll / -2}px` }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* <VertImage src={Stars} width={45} height={45} />
                <VertImage src={GiftPackage} width={100} height={85} /> */}
        <div className="gift-banner-text-container">
          <Typography.Text className="banner-title" strong>{titleText}</Typography.Text>
          <Typography.Text className="banner-subtitle">{subtitleText}</Typography.Text>
        </div>
      </div>
      {hasButton && (
        <div className="banner-button-container">
          <Link to="/gift">
            <VertButton className="banner-button" type="highlight" size="default">
              <Typography.Text className="banner-button-text" strong>{buttonText}</Typography.Text>
            </VertButton>
          </Link>
        </div>
      )}
    </div>
  );
};

export default GiftBanner;
